import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import IndustryPage from "@/pages/IndustryPage";

export const Route = createFileRoute("/zh-cn/industries/medical-devices/")({
  head: () => buildRouteHead("/zh-cn/industries/medical-devices"),
  component: IndustryPage,
});

